import { isNumber as t } from "./isNumber.js";
function n(r) {
  return typeof r != "string" && !t(r) || Number.isNaN(Number(r)) || r === "" ? null : Number(r);
}
export {
  n as tryParseNumber
};
